var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._b({class:_vm.classes,attrs:{"aria-hidden":"true","role":"img"}},'i',_vm.binding,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }